query Link($id: ID!) {
  link(id: $id) {
    id
    title
    slug
    linkType
    href
    targetType
    targetId
    targetTitle
    url
    targetUrl
    utmSource
    utmMedium
    utmCampaign
    utmTerm
    utmContent
    reward {
      type
      percent
      fixedAmount
      fixedCurrency
    }
    createdAt
    updatedAt
  }
}
